function Footer() {

  const styles = {
    backgroundColor: '#1976d2',
    color: '#FFF',
    padding: '1px',
    textAlign: 'center',
    position: 'relative',
    bottom: '0'
  }

  return (
    <footer style={styles}>
      <p>
        <span>ZSSN &copy; 2022</span>
      </p>
    </footer>
  )
}

export default Footer